<latch-base-modal>
  <div class="messages-modal-card">
    <div class="icon success" [class]="messageModalType">
      <img src="/manager/assets/images/check-mark.svg">
    </div>
    <div class="message">{{message}}</div>
  </div>
</latch-base-modal>
